export const pushToDataLayer = (eventName: string, payload?: object) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload,
  });
};
